import { useQuery } from "@tanstack/react-query";
import list from "../services/users/list";

export const useUsers = () => {
  return useQuery({
    queryKey: ["users"],
    queryFn: list,
    initialData: [],
  });
};
